// extracted by mini-css-extract-plugin
export var actionPlaceholder = "_91-3";
export var contentContainer = "_91-0";
export var editorContainer = "_91-1";
export var quillInputForm = "_91-2";
export var zoneDivider = "_91-4";